function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-play-1 {\n        fill: #fff;\n      }\n\n      .cls-play-2 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  y1: -38.225,
  x2: 0.997,
  y2: -38.225,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3023ae"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#c86dd7"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "play",
  transform: "translate(-494.108 -591.727)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_8",
  "data-name": "Elipse 8",
  className: "cls-play-1",
  cx: 15.449,
  cy: 15.449,
  r: 15.449,
  transform: "translate(494.108 591.727)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_103",
  "data-name": "Trazado 103",
  className: "cls-play-2",
  d: "M516.194,608.7l-7.725,6.092a1.875,1.875,0,0,1-3.046-1.414V601.084a1.862,1.862,0,0,1,3.046-1.415l7.725,6.093A1.837,1.837,0,0,1,516.194,608.7Z"
}));

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.899,
    height: 30.899,
    viewBox: "0 0 30.899 30.899",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.7d06e95f.svg";
export { ForwardRef as ReactComponent };